import React, { useState } from 'react';

const HospitalityDemoSimulator = () => {
    const [feedback, setFeedback] = useState(null);

    const chooseOption = (choice) => {
        let newFeedback = {};
        let feedbackClass = '';

        switch(choice) {
            case 'evacuate':
                newFeedback = {
                    title: "Correct and Decisive Action",
                    text: "In a fire emergency, a full-scale evacuation is the safest and most critical first step. It prioritizes lives above all else and prevents a potential tragedy. A leader must act quickly and decisively in the face of a crisis."
                };
                feedbackClass = "border-green-500 bg-green-100 text-green-900";
                break;
            case 'investigate':
                newFeedback = {
                    title: "A Costly Delay",
                    text: "Sending a team to investigate before evacuating is a critical mistake. It places your staff at risk and wastes valuable time that could be used to save lives. You must always assume the worst and prioritize the safety of all guests."
                };
                feedbackClass = "border-red-500 bg-red-100 text-red-900";
                break;
            case 'direct':
                newFeedback = {
                    title: "Incomplete and Dangerous",
                    text: "While directing guests to an exit is a good start, doing so without a full evacuation announcement is irresponsible. You are only helping a fraction of the hotel's guests, and the rest may not be able to find their way out in the chaos. A leader's actions must be complete and comprehensive."
                };
                feedbackClass = "border-yellow-500 bg-yellow-100 text-yellow-900";
                break;
            case 'call_fd':
                newFeedback = {
                    title: "A Failure to Act",
                    text: "Calling the fire department is a necessary step, but it is not the only one. Your primary responsibility is the safety of the people under your care. A leader must take charge of a situation and do everything in their power to ensure the well-being of others."
                };
                feedbackClass = "border-purple-500 bg-purple-100 text-purple-900";
                break;
            default:
                 newFeedback = { title: "Error", text: "Invalid choice selected." };
                 feedbackClass = "border-gray-500 bg-gray-100 text-gray-900";
        }
        setFeedback({ ...newFeedback, class: feedbackClass });
    };

    // Correct path to your local asset
    const pageStyles = {
        fontFamily: "'Inter', sans-serif",
        backgroundImage: "url('/assets/backgrounds/demo/hotel_demo_bkgr.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
    };

    return (
        // Applied pageStyles here to fix the background
        <div className="flex flex-col items-center min-h-screen p-4" style={pageStyles}>
            
            <div className="bg-gray-900/80 backdrop-blur-sm shadow-2xl rounded-3xl p-8 max-w-2xl w-full text-center text-white flex-grow flex flex-col justify-center my-auto">
                {/* Header Banner */}
                <div className="bg-purple-800 rounded-t-3xl -mt-8 -mx-8 px-8 py-6 shadow-xl border-b-4 border-white">
                    <h2 className="text-xl font-bold tracking-wide">Hotel Emergency Simulation</h2>
                </div>

                {/* Simulator Content */}
                <div className="p-4 mt-6">
                    <h1 className="text-3xl font-extrabold text-white mb-2">🛎️ Fire Alarm Reported</h1>
                    <p className="text-lg text-gray-300 mb-6">
                        You are the Hotel Manager on duty. The fire alarm has just been triggered on the 10th floor. Guests are calling the front desk in a panic, and you smell smoke.
                    </p>

                    <div className="bg-gray-800 p-6 rounded-2xl shadow-inner text-left mb-6 border-l-4 border-white">
                        <h3 className="text-xl font-bold text-orange-400 mb-2">⚠️ Situation</h3>
                        <p className="text-gray-300 text-sm">
                            Your team is looking to you for instructions. A guest on the 10th floor reports that their room is filling with smoke. You must act immediately to ensure the safety of all guests and staff.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <button onClick={() => chooseOption('evacuate')} className="w-full py-3 px-6 bg-red-600 text-white font-bold rounded-xl text-lg shadow-lg hover:bg-red-700 transition-transform duration-200 transform hover:scale-105">
                            🚨 Announce Full Evacuation
                        </button>
                        <button onClick={() => chooseOption('investigate')} className="w-full py-3 px-6 bg-green-600 text-white font-bold rounded-xl text-lg shadow-lg hover:bg-green-700 transition-transform duration-200 transform hover:scale-105">
                            🕵️ Investigate the Alarm
                        </button>
                        <button onClick={() => chooseOption('direct')} className="w-full py-3 px-6 bg-gray-600 text-white font-bold rounded-xl text-lg shadow-lg hover:bg-gray-700 transition-transform duration-200 transform hover:scale-105">
                            ➡️ Direct Guests to Stairwell
                        </button>
                        <button onClick={() => chooseOption('call_fd')} className="w-full py-3 px-6 bg-blue-600 text-white font-bold rounded-xl text-lg shadow-lg hover:bg-blue-700 transition-transform duration-200 transform hover:scale-105">
                            📞 Call Fire Department Only
                        </button>
                    </div>

                    {/* Result Display Area */}
                    <div id="result" className="mt-8 min-h-[100px]">
                        {feedback && (
                            <div className={`p-6 rounded-2xl text-left shadow-xl border-l-4 ${feedback.class}`}>
                                <h4 className="text-xl font-bold mb-2">💡 {feedback.title}</h4>
                                <p className="font-semibold text-sm">{feedback.text}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HospitalityDemoSimulator;